(ns quuppa.qsm.release.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  ::previous-installation
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :previous-installation])))
